import { EditorChangeType } from '../types';

import type { Track } from '../models/Track';
import type { VideoEditor } from '../VideoEditor';
import type { Command } from './Command';

export class TrackLayerUpCommand implements Command {
  private editor: VideoEditor;

  getName(): string {
    return 'TrackLayerUpCommand';
  }

  shouldCreateUndoRedoEntry(): boolean {
    return true;
  }

  private originalTrackId: string;
  private track?: Track;
  private executed: boolean = false;

  constructor(editor: VideoEditor, trackId: string) {
    this.editor = editor;
    this.originalTrackId = trackId;
    this.track = editor.getTrackById(trackId);
  }

  execute(): boolean {
    if (!this.track) return false;

    const trackManager = this.editor.getTrackManager();
    const result = trackManager.shiftTrackLayer(this.track.id, 'up');

    if (result) {
      this.executed = true;

      this.editor.markDirty('track_layer_up_command');

      this.editor.notifyObservers(EditorChangeType.TRACK_LAYER_CHANGED, {
        direction: 'up',
        trackId: this.track.id,
        track: this.editor.timeline.getTrack(this.track.id),
        targetTrackId: result,
      });

      return true;
    }

    return false;
  }

  undo(): boolean {
    if (!this.executed || !this.track) return false;

    const trackManager = this.editor.getTrackManager();
    const success = trackManager.shiftTrackLayer(this.track.id, 'down');

    if (success) {
      this.executed = false;

      this.editor.markDirty('track_layer_up_command_undo');

      this.editor.notifyObservers(EditorChangeType.TRACK_LAYER_CHANGED, {
        direction: 'down',
        trackId: this.track.id,
        track: this.editor.timeline.getTrack(this.track.id),
        targetTrackId: this.originalTrackId,
      });

      return true;
    }

    return false;
  }

  redo(): boolean {
    if (this.executed) return false;
    return this.execute();
  }

  getDescription(): string {
    return `Move track ${this.originalTrackId} layer up`;
  }
}
